import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { PaxFormControlBase } from './pax-form-control-base';

@Injectable()
export class PaxFormControlService {
  constructor() {}

  toFormControl(control: PaxFormControlBase<any>): FormControl {
    let validators = this.mapValidators(control.validation || []);
    return new FormControl(control.value || '', validators);
  }

  toFormGroup(controls: PaxFormControlBase<any>[]): FormGroup {
    let group: any = {};
    controls.forEach(control => {
      let validators = this.mapValidators(control.validation || []);
      group[control.key] = new FormControl(control.value || '', validators);
    });
    return new FormGroup(group);
  }

  mapValidators(rules): any {
    return rules.map(rule => {
      switch (rule.name) {
        case 'required':
          return Validators.required;
        case 'requiredTrue':
          return Validators.requiredTrue;
        case 'pattern':
          return Validators.pattern(rule.condition);
        case 'minLength':
          return Validators.minLength(rule.condition);
        case 'maxLength':
          return Validators.maxLength(rule.condition);
        default:
          return;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/pax-form-control/pax-form-control.service.ts